//
// Copyright (c) 2020 Astute Global, Inc.
//

define(["marionette", "./template/reviewTypeToggleTemplate.html"], function (
  Marionette,
  ReviewTypeToggleTemplate,
) {
  "use strict";

  let ReviewTypeToggleView = {};

  ReviewTypeToggleView.view = Marionette.ItemView.extend({
    template: ReviewTypeToggleTemplate,
    events: {
      "click .assigned-tasks-tab": function () {
        this.trigger("show:reviewType:assignedTasks");
      },
      "click .my-tasks-tab": function () {
        this.trigger("show:reviewType:myTasks");
      },
      "click .other-tasks-tab": function () {
        this.trigger("show:reviewType:otherTasks");
      },
    },
    selectAssignedTasks: function () {
      //Use the bootstrap-y way of selecting the tab
      this.$el.find("a.assigned-tasks-tab").tab("show");
    },
    selectMyTasks: function () {
      //Use the bootstrap-y way of selecting the tab
      this.$el.find("a.my-tasks-tab").tab("show");
    },
    selectOtherTasks: function () {
      //Use the bootstrap-y way of selecting the tab
      this.$el.find("a.other-tasks-tab").tab("show");
    },
  });

  return ReviewTypeToggleView;
});
